import * as THREE from 'three';

/**
 * Create the outer frame border: 4 box strips forming a rectangular frame.
 * Origin at bottom-left corner. Frame faces toward +Z.
 */
export function createOuterFrame(
  totalWidth: number,
  totalHeight: number,
  profileWidth: number,
  profileDepth: number,
  material: THREE.Material,
): THREE.Group {
  const group = new THREE.Group();
  group.name = 'outer-frame';

  const hw = profileWidth / 2;

  // Bottom
  const bottomGeo = new THREE.BoxGeometry(totalWidth, profileWidth, profileDepth);
  const bottom = new THREE.Mesh(bottomGeo, material);
  bottom.position.set(totalWidth / 2, hw, 0);
  bottom.castShadow = true;
  bottom.receiveShadow = true;
  group.add(bottom);

  // Top
  const topGeo = new THREE.BoxGeometry(totalWidth, profileWidth, profileDepth);
  const top = new THREE.Mesh(topGeo, material);
  top.position.set(totalWidth / 2, totalHeight - hw, 0);
  top.castShadow = true;
  top.receiveShadow = true;
  group.add(top);

  // Left
  const leftGeo = new THREE.BoxGeometry(profileWidth, totalHeight - 2 * profileWidth, profileDepth);
  const left = new THREE.Mesh(leftGeo, material);
  left.position.set(hw, totalHeight / 2, 0);
  left.castShadow = true;
  left.receiveShadow = true;
  group.add(left);

  // Right
  const rightGeo = new THREE.BoxGeometry(profileWidth, totalHeight - 2 * profileWidth, profileDepth);
  const right = new THREE.Mesh(rightGeo, material);
  right.position.set(totalWidth - hw, totalHeight / 2, 0);
  right.castShadow = true;
  right.receiveShadow = true;
  group.add(right);

  return group;
}
